import { useEffect, useRef } from "react"
import {
  headingsPlugin,
  imagePlugin,
  listsPlugin,
  markdownShortcutPlugin,
  MDXEditor,
  MDXEditorMethods,
  tablePlugin,
  thematicBreakPlugin,
} from "@mdxeditor/editor"
import dayjs from "dayjs"
import styled from "styled-components"

import { ApiTypes } from "types"
import { ReactComponent as DateIcon } from "assets/svg/message-report-date.svg"
import { ReactComponent as MessageIcon } from "assets/svg/message-report-message.svg"
import { ReactComponent as TitleIcon } from "assets/svg/message-report-title.svg"

import decodeToMarkDown from "utils/markdown/decodeToMarkDown"

import styles from "./index.module.scss"

const StatusCount = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${({ color }) => color};
`

type HeaderTilesProps = {
  messageBatchData: ApiTypes.Model.MessageBatch | undefined
}

export const HeaderTiles = ({ messageBatchData }: HeaderTilesProps) => {
  const {
    created_at: createdAt,
    title,
    content_rich: bodyRich,
    delivered_count,
    failed_delivery_count,
    pending_delivery_count,
  } = messageBatchData || {}
  const editorRef = useRef<MDXEditorMethods>(null)

  useEffect(() => {
    if (bodyRich && editorRef.current) {
      editorRef.current.setMarkdown(decodeToMarkDown(bodyRich))
    }
  }, [bodyRich])

  return (
    <div className={styles.detailsWrapper}>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>
          <DateIcon className={styles.detailsIcon} />
          Date
        </h3>
        <div className={styles.detailsText}>{createdAt ? dayjs(createdAt).format("MM-DD-YYYY") : ""}</div>
      </div>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>
          <TitleIcon className={styles.detailsIcon} />
          Title
        </h3>
        <div className={styles.detailsText}>{title}</div>
      </div>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>
          <MessageIcon className={styles.detailsIcon} />
          Message
        </h3>
        <div className={styles.detailsText}>
          <MDXEditor
            className={styles.markdownWrapper}
            markdown={bodyRich ? decodeToMarkDown(bodyRich) : ""}
            readOnly={true}
            ref={editorRef}
            plugins={[
              headingsPlugin(),
              listsPlugin(),
              tablePlugin(),
              thematicBreakPlugin(),
              markdownShortcutPlugin(),
              imagePlugin(),
            ]}
          />
        </div>
      </div>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>Delivered</h3>
        <StatusCount color="#2db2c8">{delivered_count || 0}</StatusCount>
      </div>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>Pending</h3>
        <StatusCount color="#f59e0b">{pending_delivery_count || 0}</StatusCount>
      </div>
      <div className={styles.detailsItem}>
        <h3 className={styles.detailsTitle}>Failed</h3>
        <StatusCount color="#ef4444">{failed_delivery_count || 0}</StatusCount>
      </div>
    </div>
  )
}

export default HeaderTiles
